export default __webpack_public_path__ + "static/QuickStart-97b1a7b80b983c4f7bcff65cee6c1682.jpg";